export default "__VITE_ASSET__D01hG_S1__"